<template>
  <div v-if="survey.orgAccessTypeId > 1">
    <div class="row justify-content-center">
      <div class="col text-center">
        <h3>{{ survey.surveyName }}</h3>
      </div>
    </div>
    <div v-if="errorMessage.length" class="row justify-content-center">
      <div class="col-lg-6">
        <base-alert class="text-center" type="danger">{{ errorMessage }}</base-alert>
      </div>
    </div>
    <div class="container login-page">
      <div class="col-lg-4 col-md-6 ml-auto mr-auto">
        <validation-observer ref="observer" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(login)">
            <card class="card-login card-white">
              <template slot="header">
                <img :src="`img/${cardBackground}`" alt="Message Background" />
                <h1 class="card-title">Log in</h1>
              </template>

              <div>
                <validation-provider rules="requiredCode" v-slot="{ errors }">
                  <base-input
                    name="code"
                    placeholder="Access Code"
                    addon-left-icon="tim-icons icon-key-25"
                    v-model="accessCode">
                  </base-input>
                  <h6 v-if="errors.length" class="text-danger">
                    <span>{{ errors[0] }}</span>
                  </h6>
                </validation-provider>
              </div>

              <div slot="footer">
                <base-button native-type="submit" :type="colorScheme" class="mb-3" size="lg" block>
                  Access Survey
                </base-button>
              </div>
            </card>
          </form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { BaseAlert } from '../../components';

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    BaseAlert
  },
  data() {
    return {
      accessCode: null,
      errorMessage: ''
    }
  },
  computed: {
    cardBackground() {
      if (this.colorScheme !== 'primary') {
        return this.$store.state.themes[this.colorScheme].loginImage;
      }

      return 'card-primary.png';
    },
    colorScheme() {
      return this.$store.getters.themeColor(this.$route.params.surveyId) || 'primary';
    },
    survey() {
      return this.$store.getters.getOrgSurveyByUrlId(this.$route.params.surveyId) || {};
    }
  },
  methods: {
    login() {
      this.errorMessage = '';

      this.$store
        .dispatch('authenticateUser', {
          surveyUrlId: this.survey.surveyUrlId,
          surveyAccessCode: this.accessCode
        })
        .then(() => {
          this.$router.push({ path: `/surveys/${this.survey.surveyUrlId}/auth` });
        })
        .catch((error) => {
          if(error.response) {
            if(error.response.status === 401) {
              this.errorMessage = 'The supplied access code is not valid. Please try again.'
            }
            else if(error.response.status === 500) {
              this.errorMessage = 'An internal error has occurred. Please contact the system administrator.'
            }
            else {
              this.errorMessage = JSON.stringify(error);
            }
          }
        });
    }
  }
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
</style>
